<template>
  <div>
    <vs-prompt title="Mağaza Güncelle" acceptText="Güncelle" cancelText="Vazgeç" :active.sync="activePrompt"
      @accept="magazaGuncelle">
      <div class="con-exemple-prompt">
        <span>Mağaza</span>
        <v-select v-model="magazaSecilen" :options="magazaList" style="">
          <template slot="option" slot-scope="option">
            {{ option.magazaAdi }} / {{ option.magazaKodu }}
          </template>
          <template slot="selected-option" slot-scope="option">
            {{ option.magazaAdi }} / {{ option.magazaKodu }}
          </template>
        </v-select>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import state from "../../../store/state";
import Store from "../../../store/store";
import vSelect from "vue-select";
export default {
  data() {
    return {
      magazaList: [],
      activePrompt: false,
      magazaSecilen: "",
    };
  },
  components: {
    "v-select": vSelect,
  },
  created() {
    this.activePrompt = true;
    this.magazaListesi();
    this.ekYetkiler = Store.state.ekYetkiler;
  },
  methods: {
    magazaGuncelle() {
      console.log(this.params.data.siparisRef);
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.ekYetkiler == 'admin') {
        if (vm.magazaSecilen == "") {
          vs.notify({
            title: "Mağaza",
            text: "Mağaza seçimi yapmadınız",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
        } else {
          const args = {
            token: Store.state.tokenId,
            siparisRef: vm.params.data.siparisRef,
            MagazaKodu: vm.magazaSecilen.magazaKodu,
          };
          console.log(args);
          soap.createClient(url, function (err, client) {
            client.magazaGorevDegistir(args, function (err, result) {
              if (result.magazaGorevDegistirResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              vm.veriler = JSON.parse(result.magazaGorevDegistirResult);
            });
          });
          vm.$root.$emit("magazagorevlist");
          vm.magazaSecilen = "";
        }
      }
    },
    magazaListesi() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.magazaListesi(args, function (err, result) {
          if (result.magazaListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.magazaListesiResult);
          vm.magazaList = vm.veriler;
        });
      });
    },
  },
};
</script>